// Re-export everything from our centralized firebase initialization module
import firebase, {
  readyApp,
  analytics,
  firestore,
  db,
  ref,
  storage,
  sto,
  database,
  FirestoreTimestamp,
  auth as firebaseauth
} from "../firebaseInit"

// For backward compatibility
export const firebaseAuth = firebase.auth

// Re-export everything
export {
  readyApp,
  analytics,
  firestore,
  db,
  ref,
  firebaseauth,
  storage,
  sto,
  database,
  FirestoreTimestamp
}

export default firebase
